import React from 'react';
import CallReportPage from '../components/reports/CallReportPage';

const DataCallReport: React.FC = () => <CallReportPage title="Data Call Report" reportType="lead" />;

export default DataCallReport;

